<template>
<div class="content">
        <div class="row">
          <div class="col">
         <div > 
        <div class="card text-dark bg-light mb-3" style="" >
        <div class="card-header text-danger"><h5>FİRMA BİLGİLERİ</h5></div>
        <div class="card-body" >
            <div class="row">
                <div class="col-9">
                    <h5 class="card-title"> {{getCompany[getSelectedCompany].adi}}</h5>
                </div>
                <div @click="goToBack" class="col-2"><button class="btn btn-success btn-round">LİSTEYE DÖN</button></div>
            </div>
            <hr>
            <h5 class="card-title text-danger">GENEL BİLGİLER</h5>
            <hr>
            <div class="container">
            <div class="row">
                <div class="col">
                    <p class="card-text">SEKTÖR : {{getCompany[getSelectedCompany].sektor}} </p>
                </div>
                <div class="col">
                    <p class="card-text">KONTENJAN : {{getCompany[getSelectedCompany].kontenjan}} </p>
                </div>
            </div>
            <br>          
            
            </div>
            <hr>
            <h5 class="card-title text-danger">İLETİŞİM BİLGİLERİ</h5>   
            <hr>  
             <div class="row">
                <div class="col">
                    <p class="card-text">FİRMADAKİ İLGİLİ : {{getCompany[getSelectedCompany].ilgili}}  </p>
                </div>
            </div>  
            <br>    
            <div class="row">
                <div class="col">
                    <p class="card-text">ADRES : {{getCompany[getSelectedCompany].adres}} </p>
                </div>
            </div>
            <br>
            <div class="row">
                <div class="col">
                    <p class="card-text">TELEFON : {{getCompany[getSelectedCompany].telefon}} </p>
                </div>
                <div class="col">
                    <p class="card-text">E POSTA : {{getCompany[getSelectedCompany].eposta}} </p>
                </div>
            </div>
            <hr>
            <h5 class="card-title text-danger">İLGİLİ AKADEMİSYEN</h5>
            <hr>
            <div class="row">
                <div class="col">
                    <p class="card-text">AKADEMİSYEN ADI : {{getCompany[getSelectedCompany].akademisyenAdi}} </p>
                </div>
               
            </div>
            <hr>
            <h5 class="card-title text-danger">ÜRÜN HİZMET DETAYLARI</h5>
            <hr>
            <div class="row">
                <div class="col">
                    <p class="card-text">ÜRÜNLER : {{getCompany[getSelectedCompany].urunler}} </p>
                </div>
            </div>
            <br>
            <div class="row">
                <div class="col">
                    <p class="card-text">PARKURLAR : {{getCompany[getSelectedCompany].parkurlar}} </p>
                </div>
            </div>
            <br>
            <div class="row">
                <div class="col">
                    <p class="card-text">SERTİFİKASYONLAR : {{getCompany[getSelectedCompany].sertifikasyonlar}} </p>
                </div>
            </div>
             <hr>
            <h5 class="card-title text-danger">PERSONEL NİTELİĞİ</h5>
            <hr>
            <div class="row">
                <div class="col">
                    <p class="card-text">DOKTORA : {{getCompany[getSelectedCompany].doktora}} </p>
                </div>
            </div>
            <br>
             <div class="row">
                <div class="col">
                    <p class="card-text">YÜKSEK LİSANS : {{getCompany[getSelectedCompany].yukseklisans}} </p>
                </div>
            </div>
            <br>
             <div class="row">
                <div class="col">
                    <p class="card-text">LİSANS : {{getCompany[getSelectedCompany].lisans}} </p>
                </div>
            </div>
             <hr>
            <h5 class="card-title text-danger">İSTİSNAİ DURUMLAR</h5>
            <hr>
            <div class="row">
                <div class="col">
                    <p class="card-text">{{getCompany[getSelectedCompany].istisna}}</p>
                </div>
            </div>
            <br>
            <hr>
            <h5 class="card-title text-danger">ÖĞRENCİ EŞLEŞTİRME TABLOSU </h5>
            <hr>
            <div class="row">
                <div class="col-4">
                <input v-model="ogrenci.adi"   type="text" class="form-control" placeholder="ÖĞRENCİ ADI/SOYADI" >
                </div>
                 <div class="col-4">
                <input v-model="ogrenci.no"  type="text" class="form-control" placeholder="ÖĞRENCİ NO" >
                </div>
                 <div class="col-4">
                <input v-model="ogrenci.bolum"  type="text" class="form-control" placeholder="BÖLÜM/PROGRAM" >
                </div>
            </div>
            <div class="row">
                <div class="update ml-auto mr-auto">
                    <button @click="ogrenciEkle" class="btn btn-round btn-success">EKLE</button>
                </div>
            </div>

            <div class="row" v-for="(a,b,c) in getCompany[getSelectedCompany].ogrencilistesi" :key="a.key">
                <div class="col mt-3" >
                    <p><strong>ADI SOYADI : </strong>{{a.adi}}</p>
                </div>
                <div class="col mt-3" >
                    <p><strong>NO : </strong>{{a.no}}</p>
                </div>
                <div class="col mt-3" >
                    <p><strong>BÖLÜM/PROGRAM : </strong>{{a.bolum}}</p>
                </div>
                <div class="col" >
                    <button class="btn btn-danger" @click="bilgi(b)">SİL</button>
                </div>
            </div>
            
            </div>
                  <br>


         
            <br>
            <div class="row ">
               <div class="update ml-auto mr-auto">
                    <button class="btn btn-danger btn-round  ">YAZDIR</button>
               </div>  
                
            </div>
            
        </div>
</div>
    </div>
          </div>
        </div>




   

   
</template>
<script>
import { mapGetters} from "vuex";

export default {
    computed : {
      ...mapGetters(["getCompany","getSelectedCompany","getStudents","getselectedStudentList","getscompany"])
    },
    data (){
      return {
         ogrenci :  {
             adi:"",
             no:"",
             bolum:""
         }
      }
    }, 
    methods :{
        goToBack(){
        this.buttonClicked = true
        this.$router.push("/company")
      },
      ogrenciEkle(){
        console.log(this.ogrenciliste)
         this.$store.dispatch("ogrenciEkle",this.ogrenci);
        this.$router.push("/company")

    },
    bilgi(e){
        console.log(e)
        this.$store.dispatch("ogrenciSil",e);
        this.$router.push("/company")

    }

    },
    
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/company/CompanyInfo.vue